import React, { useContext, useMemo, useState } from "react";
const defaultAppContext = {
    isSwitchOrg: false,
    setIsSwitchOrg: () => { },
    isFormDirty: false,
    setIsFormDirty: () => { },
    setDirtyFormResourceName: () => { },
    dirtyFormResourceName: '',
    setIsLegacyOrg: () => { },
    isLegacyOrg: false,
};
export const AppContext = React.createContext(defaultAppContext);
export const useAppContext = () => useContext(AppContext);
export const AppContextProvider = (props) => {
    const [isSwitchOrg, setIsSwitchOrg] = useState(false);
    const [isFormDirty, setIsFormDirty] = useState(false);
    const [isLegacyOrg, setIsLegacyOrg] = useState(false);
    const [dirtyFormResourceName, setDirtyFormResourceName] = useState(null);
    const contextValue = useMemo(() => ({ isSwitchOrg, setIsSwitchOrg, isFormDirty, setIsFormDirty, dirtyFormResourceName, setDirtyFormResourceName, isLegacyOrg, setIsLegacyOrg }), [isSwitchOrg, isFormDirty, dirtyFormResourceName, isLegacyOrg]);
    return (React.createElement(AppContext.Provider, { value: contextValue }, props.children));
};
